export const DM_DELIVERY_CLICK_AND_COLLECT = 'delivery_click_and_collect';
export const DM_DELIVERY_ADDRESS = 'delivery_address';
export const DM_DELIVERY_GLS_PICKUP = 'delivery_gls_pickup';
export const DM_DELIVERY_GLS_LOCKER = 'delivery_gls_locker';
export const DM_DELIVERY_FOXPOST_LOCKER = 'delivery_foxpost_locker';
export const DM_DELIVERY_FOXPOST_PICKUP = 'delivery_foxpost_pickup';
export const DM_DELIVERY_COOLOMAT_LOCKER = 'delivery_coolomat_locker';
export const DM_DELIVERY_PICKUP_OR_LOCKER = 'delivery_pickup_or_locker';
export const DM_DELIVERY_PICKUP = 'delivery_pickup';
export const DM_DELIVERY_LOCKER = 'delivery_locker';
export const DM_DELIVERY_COOLOMAT = 'delivery_coolomat';
